import { render } from "./ChoiceCard.vue?vue&type=template&id=ece5203c&scoped=true"
import script from "./ChoiceCard.vue?vue&type=script&lang=js"
export * from "./ChoiceCard.vue?vue&type=script&lang=js"

import "./ChoiceCard.vue?vue&type=style&index=0&id=ece5203c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece5203c"]])

export default __exports__